import React from 'react';
import { ReturnButtons } from '../shared/ReturnButtons';
import { ReturnHeaders } from '../shared/ReturnHeaders';
import { goToNextStep, goToPreviousStep } from '../../stores/newFlowStore';
import BoxPickers from './BoxPickers';

export const DropOffBoxes = () => {
  return (
    <div className="sui-mb-4">
      <ReturnHeaders title="Number of boxes to drop off" />
      <BoxPickers />
      <ReturnButtons
        proceedNext={goToNextStep}
        proceedBack={goToPreviousStep}
      />
    </div>
  );
};
